import React from 'react';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import withApollo from '../lib/apollo';
import profilesConnectionQuery
from '../lib/queries/products/profilesConnectionQuery.graphql';
import DirectoryList from '../components/DirectoryPage/List';
import { DirectoryPage, DirectoryLayout } from '../components/DirectoryPage';
import messages from '../lib/messages.mjs';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import {
  directoryCardImageConfigurations,
  directoryCardLogoConfigurations,
} from '../lib/imageConfigurations';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/CJSa5cBnnnNPNZ8_FG0LkQP541cxjXe_qq0Ij4w-kuU/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9zb2Z0d2FyZTEuanBn',
    'https://r.fashionunited.com/JuXcyejA7ExAUFCtlFfyhcXaPGZR3EA8zM-Upl-vrXw/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9zb2Z0d2FyZTEuanBn',
    'https://r.fashionunited.com/_ZWMAr8MvMl-Q_5sK-3hFOjiRBHkEd6C2QX5h6USxwc/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9zb2Z0d2FyZTEuanBn',
  ],
  desktop: [
    'https://r.fashionunited.com/-JIDenwSzdEndz00nqrBsmBOzL9u_Vg2poExA_wFfIY/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9zb2Z0d2FyZTEuanBn',
    'https://r.fashionunited.com/enmckU32YUzi6lEp3L8utGjCO6sQZTVewkZ7zz87hqw/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9zb2Z0d2FyZTEuanBn',
    'https://r.fashionunited.com/Zf5YULOT1r-cNhIFdUqEFxz9iseTBwVZnUkgaLq5v4A/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9zb2Z0d2FyZTEuanBn',
    'https://r.fashionunited.com/iR47AZ9R-O7HZ5Ne9pE8JnNjXAlX1lZzL6sgev-rP8M/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9zb2Z0d2FyZTEuanBn',
  ],
};

export const SoftwareSuppliersDirectoryPage = () => {
  const intl = useIntl();
  const {
    query: {
      country,
      section,
      search,
    },
  } = useRouter();

  const SOFTWARE_SUPPLIERS_LIMIT = 20;

  return (
    <DirectoryPage
      title={intl.formatMessage(messages['software-suppliers-directory.title'])}
      route="software-suppliers-directory"
      pageType="software-suppliers"
      ComponentWithQuery={DirectoryList}
      variables={{
        type: 'SOFTWARE_SUPPLIER',
        first: SOFTWARE_SUPPLIERS_LIMIT,
        search,
        premium: section !== 'all' || null,
        country: country || null,
        imageConfigurations: directoryCardImageConfigurations,
        logoConfigurations: directoryCardLogoConfigurations,
      }}
      query={profilesConnectionQuery}
    />
  );
};

SoftwareSuppliersDirectoryPage.getLayout = (page) => (
  <DirectoryLayout
    imageUrls={headerImageUrls}
    alt="FashionUnited Software Suppliers Directory"
  >
    {page}
  </DirectoryLayout>
);

SoftwareSuppliersDirectoryPage.getInitialProps = redirectRouteToDomain(
  'software-suppliers-directory',
);

export default withApollo(SoftwareSuppliersDirectoryPage);
